import styled from "styled-components";
import { Container } from "react-bootstrap";

export const Wrapper = styled(Container)`
  max-width: 530px;
  button {
    box-shadow: var(--box-shadow1);
    &:disabled {
      box-shadow: none;
    }
  }
  .select {
    [class$="control"] {
      background: transparent;
      height: 50px;
      border: 1px solid var(--text-color-muted);
      border-radius: 6px;
    }
    [class$="singleValue"] {
      font-weight: 500;
      font-size: var(--font-size-sm);
      color: var(--text-color-muted);
    }
    [class$="menu"] {
      width: 130px;
    }
  }

  .input {
    height: 50px;
    border: 1px solid var(--text-color-muted);
    border-radius: 6px;
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--text-color-muted);
    position: relative;
    input {
      background: transparent;
      &:disabled {
        color: var(--text-color-muted);
      }
    }
  }
  .disabled-input {
    [class$="control"] {
      opacity: 0.5;
    }
  }
  .invalid-input {
    border: 1px solid var(--danger-color);
    border-radius: 6px;
  }
  .error-message {
    color: var(--danger-color);
    font-weight: 300;
    font-size: 10px;
    color: var(--danger-color);
    position: absolute;
  }
`;
